import React from 'react';
import { MaturityScheduleResponse } from '../../model/MaturitySchedule.model';

interface CreatedTodayStatisticsProps {
  data: MaturityScheduleResponse[];
}

const CreatedTodayStatistics: React.FC<CreatedTodayStatisticsProps> = ({
  data,
}) => {
  const total = data.length;
  const pending = data.filter(
    (ms) => ms.status === 'PENDING' || ms.status === 'PAID'
  ).length;
  const overdue = data.filter((ms) => ms.status === 'OVERDUE').length;
  const completed = data.filter((ms) => ms.status === 'COMPLETED').length;
  const abandoned = data.filter((ms) => ms.status === 'ABANDONED').length;

  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-6">
      <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
        <div className="text-blue-600 text-sm font-medium">
          Tổng số kỳ đáo hạn
        </div>
        <div className="text-2xl font-bold text-blue-700">{total}</div>
      </div>
      <div className="bg-orange-50 p-4 rounded-lg border border-orange-200">
        <div className="text-orange-600 text-sm font-medium">
          Đang chờ xử lý
        </div>
        <div className="text-2xl font-bold text-orange-700">{pending}</div>
      </div>
      <div className="bg-red-50 p-4 rounded-lg border border-red-200">
        <div className="text-red-600 text-sm font-medium">Quá hạn</div>
        <div className="text-2xl font-bold text-red-700">{overdue}</div>
      </div>
      <div className="bg-green-50 p-4 rounded-lg border border-green-200">
        <div className="text-green-600 text-sm font-medium">Đã hoàn thành</div>
        <div className="text-2xl font-bold text-green-700">{completed}</div>
      </div>
      <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
        <div className="text-gray-600 text-sm font-medium">Không làm</div>
        <div className="text-2xl font-bold text-gray-700">{abandoned}</div>
      </div>
    </div>
  );
};

export default CreatedTodayStatistics;
